export default `${process.env.REACT_APP_ARGO_API_URL}`;
